import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import { getAllSeriessPatient } from "app/services/PatientService";
import { CUSTOMER_JOURNEYS } from "app/common/LocalConst";

export default class CustomerJourneyTabStore {
  searchCustomerJourney = {
    // ...new SearchObject(),
    fromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toDate: new Date(),
    seriesType: [...CUSTOMER_JOURNEYS]
  };

  listCustomerJourney = [];

  constructor() {
    makeAutoObservable(this);
  }
  pagingCustomerJourney = async () => {
    const payload = {
      ...this.searchCustomerJourney,
      seriesType: this.searchCustomerJourney.seriesType?.map(x => x.value) || [],
    };
    return await getAllSeriessPatient(payload)
      .then(({ data }) => {
        this.listCustomerJourney = data?.listItem;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ hành trình có lỗi");
      });
  };

  handleChangeFormSearchService = (searchCustomerJourney) => {
    this.searchCustomerJourney = {
      ...this.searchCustomerJourney,
      ...searchCustomerJourney,
    };
    this.pagingCustomerJourney();
  };

  resetStore = () => {
    this.searchCustomerJourney = {
      // ...new SearchObject(),
      fromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      toDate: new Date(),
      seriesType: [...CUSTOMER_JOURNEYS],
    };
    this.listCustomerJourney = [];
  };
}
